<template>
    <div class="cover-content table-wrapper">
        <!-- <high-search> -->
            <Form ref="formInline" :model="formInline" inline class="form-list"
                  :label-width="100" label-position="right">
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="人员姓名:" prop="workerName" :label-width="78">
                            <Input v-model="formInline.workerName" placeholder="请输入人员姓名"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="身份证号:" prop="idCardNum">
                            <Input v-model="formInline.idCardNum" placeholder="请输入身份证号"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="人员类型:" prop="workRole">
                            <RadioGroup v-model="formInline.workRole">
                                <Radio :label="0">全部</Radio>
                                <Radio :label="10">管理人员</Radio>
                                <Radio :label="20">建筑工人</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="6" class="high-search">
                        <Button type="primary" @click="handleQuery">搜索</Button>
                        <Button style="margin-left: 20px" @click="handleReset">重置</Button>
                        <span :class='open ? "search-open" : "search-close"' @click='open = !open'>{{open ? '收起' : '展开'}} <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" /></span>
                    </Col>
                </Row>
                <Row :gutter="16" v-show='open'>
                    <Col span="6">
                        <FormItem label="工种类型:" prop="workType" :label-width="78">
                            <Select v-model="formInline.workType" clearable placeholder="全部">
                                <Option v-for="(item,index) in workerType" :value="item.code" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="所属企业:" prop="corpName">
                            <Input v-model="formInline.corpName" placeholder="请输入所属企业"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="人员状态:" prop="workerStatus">
                            <RadioGroup v-model="formInline.workerStatus">
                                <Radio :label="1">在岗</Radio>
                                <Radio :label="2">在册</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16" v-show='open'>
                    <Col span="6">
                        <FormItem label="项目名称:"  :label-width="78">
                            <Input v-model="formInline.projectName" placeholder="请输入项目名称"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="项目所在地:">
                            <place-select v-model="formInline.areaCode"></place-select>
                        <!--              <Select v-model="formInline.areaCode">-->
                        <!--                <Option v-for="item in area" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
                        <!--              </Select>-->
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <!--<div style="margin-bottom: 24px;">
                <Button :loading="eLoading" type="primary" @click="handleExport" icon="ios-exit-outline">导出</Button>
            </div>-->
        <!-- </high-search> -->
        <div class='cover-table'>
            <ul class="info-list" style="border: none;">
                <Spin fix v-if="loading"></Spin>
                <li class="list-no-data" style=" border: 1px solid #E9E9E9; margin-bottom: 16px;" v-if="!tableData|| (tableData&&tableData.length===0)">暂无数据</li>
                <li class="tp-item" v-for="(item,index) in tableData" :key="index" :style="`margin: ${index % 2 === 0 ? '0 0px 16px 0' : ''}`">
                    <div class='name'>
                        <span>{{item.workerName}}</span>
                        <div @click="handleDeal('personnelDetail',item.workerId)">查看详情</div>
                    </div>
                    <div class='person-info'>
                        <div>
                            <span v-if="item.headImage" class="head-wrap"><img :src="item.headImage"></span>
                            <Avatar v-else size="76" icon="ios-person" ></Avatar>
                        </div>
                        <div>
                            <div>
                                <div>基本信息</div>
                                <div>身份证号: {{item.idCardNumber}}</div>
                                <div>性别: {{item.gender}}&nbsp;&nbsp;&nbsp;年龄: {{item.age + '岁'}}&nbsp;&nbsp;&nbsp;民族: {{item.nation}} </div>
                                <div>联系电话: {{item.cellPhone}}</div>
                            </div>
                            <div>
                                <div>工作信息</div>
                                <div>公司: {{item.corpName}}</div>
                                <div>班组: {{item.teamName}}，{{item.workRole}}</div>
                                <div>&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="aFlex">

                        <div class="tp-user">
                            <span class="tp-txt-bold">{{item.workerName}}</span>
                            <div>{{item.idCardNumber}}</div>
                        </div>
                    </div>
                    <div class="tp-main">
                        <p>{{item.gender}}，{{item.nativePlace}}，{{item.age+'岁'}}，{{item.nation}}，{{item.workType}}，{{item.cellPhone}}</p>
                        <p>
                            <span class="tp-txt-bold">{{item.corpName}}</span>
                            <span>{{item.teamName}}，{{item.workRole}}</span>
                        </p>
                    </div> -->
                </li>
            </ul>
            <Page class="page_last" :total="totalCount" :page-size="pageSize" :current="page"
                  @on-change="changePage" @on-page-size-change="pageSizeChange"
                  show-elevator show-sizer show-total transfer>
            </Page>
        </div>
    </div>
</template>
<style scoped>
    .tp-user{
        margin-left: 8px;
    }
    .tp-txt-bold{
        font-weight: 700;
        color: #0066FF;
        margin-right: 10px;
        display: block;
    }
    .tp-main{
        margin: 10px 0 15px 0;
        line-height: 1.8;
    }
    .tp-bottom{
        text-align: right;
    }
    .tp-time{
        color: #cccccc;
        margin-left: 5px;
    }
</style>
<style lang="less" scoped>
    /deep/.page_last{
        .ivu-page-item-jump-next+.ivu-page-item{
            display: none;
        }
    }
    .info-list {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .tp-item{
        width: calc(~'50% - 8px');
        border: 1px solid #E9E9E9;
        font-size: 13px;
        color: #999999;
        cursor: pointer;
        height: 168px;
        display: flex;
        flex-direction: column;
        &:hover{
            background-color: #EBF7FF;
        }
        .name {
            height: 44px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 12px;
            background: #F5F7F9;
            border-bottom: 1px solid #D7DDE4;
            &>span {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #464C5B;
            }
            &>div {
                width: 80px;
                height: 28px;
                border-radius: 4px;
                border: 1px solid #3399FF;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #3399FF;
                cursor: pointer;
                text-align: center;
                line-height: 28px;
            }
        }
        .person-info {
            flex: 1;
            display: flex;
            flex-direction: row;
            padding: 12px;
            height: 100%;
            .head-wrap{
                width: 76px;
                height: 76px;
                display: inline-block;
                border-radius: 50%;
                img{
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                }
            }
            &>div:nth-child(1) {
                display: flex;
                align-items: center;
                width: 88px;
                border-right: 1px solid #D7DDE4;
            }
            &>div:nth-child(2) {
                flex: 1;
                display: flex;
                flex-direction: row;
                &>div {
                    flex: 2;
                }
                &>div:nth-child(1) {
                    border-right: 1px solid #D7DDE4;
                    padding: 0 12px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    &>div:nth-child(1) {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #9EA7B4;
                    }
                    &>div:nth-child(2), &>div:nth-child(3), &>div:nth-child(4) {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #657180;
                    }
                }
                &>div:nth-child(2) {
                    padding: 0 12px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    &>div:nth-child(1) {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #9EA7B4;
                    }
                    &>div:nth-child(2), &>div:nth-child(3) {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #657180;
                    }
                }
            }
        }
    }
</style>
<script>
    import {mapState,mapGetters} from 'vuex';
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                eLoading: false,
                open: false,
                formInline:{
                    projectName:'',
                    workerName:'',
                    idCardNum:'',
                    workRole:0,
                    workType:'',
                    corpName:'',
                    workerStatus: 2,
                    areaCode: localStorage.getItem('tenantAreaCode'),
                },
                tableData:[],
                exportData:{
                    size:this.pageSize,
                    current:this.page,
                    areaCode:this.areaCode,
                }
            };
        },
        computed:{
            ...mapState(['area']),
            ...mapGetters(['workerType']),
        },
        created(){
            this.$route.query.areaCode && (this.formInline.areaCode = this.$route.query.areaCode)
            this.formInline.workRole = this.$route.query.workRole ? this.$route.query.workRole: 0
            this.formInline.workerStatus = this.$route.query.workerStatus ? this.$route.query.workerStatus : 2
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            handleReset() {
                this.page = 1
                this.formInline = {
                    workerName:'',
                    idCardNum:'',
                    workRole:0,
                    workType:'',
                    corpName:'',
                    workerStatus:1,
                    areaCode: localStorage.getItem('tenantAreaCode'),
                }
                this.getTableData();
            },
            //导出
            handleExport(){
                let param={
                    ...this.formInline,
                    size:this.pageSize,
                    current:this.page,
                    areaCode:this.formInline.areaCode,
                };
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url:'/worker/sx/export',
                    responseType:'arraybuffer',
                    data: param,
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response,'在册人员.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            /*处理操作*/
            handleDeal(name,uuid){
                this.$router.push({
                    name: name,
                    query: {
                        workerId:uuid
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                let param={
                    ...this.formInline,
                    size:this.pageSize,
                    current:this.page,
                    areaCode:this.formInline.areaCode,
                };
                this.exportData=param;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/worker/sx/pageList',
                    data:param
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total;
                        this.tableData=response.data.data.records;
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>

